import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Badge,
} from '@mui/material'
import { type BadgeProps } from './Badge'

export type BadgeInlineProps = Pick<BadgeProps, 'children' | 'badgeContent' | 'color' | 'data-testid' | 'sx'> & {
  /**
   * Variant can be dot or standard the bigger one for content
   *
   * @default 'dot'
   */
  variant?: BadgeProps['variant']
}

export const BadgeInline = ({ children, variant = 'dot', sx, ...props }: BadgeInlineProps) => (
  <Badge variant={variant} {...props} className="DhlBadgeInline" sx={sx}>
    {children}
  </Badge>
)
